import React from "react";
import { Link } from "react-router-dom";
import { BLOGS } from "@/site";
import SEO from "@/components/SEO";
import PageHero from "@/components/sections/PageHero";
import CTABanner from "@/components/sections/CTABanner";

export default function Blog() {
    return (
        <div data-testid="page-blog">
            <SEO
                title="Music Education Blog | Ihao Music House Delhi"
                description="Guides and insights on learning music — from the faculty at Ihao Music House Delhi. Practice tips, certification comparisons and student advice."
                path="/blog"
            />
            <PageHero
                eyebrow="Blog"
                title="Insights from the studio."
                subtitle="Practice tips, certification deep-dives and honest advice from our faculty — everything you need to make smarter decisions about your music journey."
            />

            <section className="relative py-20 md:py-28 bg-background">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {BLOGS.map((b) => (
                            <Link
                                key={b.slug}
                                to={`/blog/${b.slug}`}
                                data-testid={`blog-card-${b.slug}`}
                                className="group rounded-2xl overflow-hidden border border-white/10 bg-[#121212] hover:-translate-y-1 hover:border-gold/40 transition-all duration-300"
                            >
                                <div className="aspect-[16/10] overflow-hidden">
                                    <img src={b.image} alt={b.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" loading="lazy" />
                                </div>
                                <div className="p-6">
                                    <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em] text-gold/80">
                                        <span>{new Date(b.date).toLocaleDateString("en-IN", { month: "short", day: "numeric", year: "numeric" })}</span>
                                        <span className="w-1 h-1 rounded-full bg-gold/50" />
                                        <span>{b.readTime}</span>
                                    </div>
                                    <h3 className="mt-3 font-display text-xl text-white font-semibold leading-snug">{b.title}</h3>
                                    <p className="mt-3 text-sm text-white/60 line-clamp-2">{b.excerpt}</p>
                                    <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-gold">Read article <span className="w-6 h-px bg-gold transition-all group-hover:w-10" /></span>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            <CTABanner />
        </div>
    );
}
